import slick from 'slick-carousel';

$('.slider-bloco').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow: $('.bloco-prev'),
    nextArrow: $('.bloco-next'),
    responsive: [{
        breakpoint: 1100,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        },
    },
    {
        breakpoint: 784,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
        },
    },
    ],
});
